import React from 'react'

interface SummaryGridProps {
 children: React.ReactNode
 columns?: 2 | 3 | 4
 className?: string
}

const gridCols = {
 2: 'grid-cols-1 md:grid-cols-2',
 3: 'grid-cols-1 md:grid-cols-3',
 4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
}

export const SummaryGrid: React.FC<SummaryGridProps> = ({
 children,
 columns = 2,
 className = ''
}) => {
 return (
 <div className={`grid ${gridCols[columns]} gap-4 ${className}`}>
 {children}
 </div>
 )
}

